/* Models */
import { Season } from '../models';

/* ActionTypes */
import { SEASON_ENTITY_ACTION_TYPES } from './actionTypes';

/* Utils */
import { generateEntityReducer } from '../utils/generators/reducerGenerators';

const seasonsReducer = generateEntityReducer(SEASON_ENTITY_ACTION_TYPES, Season);

export default seasonsReducer;
